export const examples = [
  {
    name: 'S3 Invoice Extraction',
    text: `I have a bunch of PDF invoices in a folder on my AWS S3 bucket. 
I need to extract the vendor names and total amounts from them. I already have a JSON sample of what the output should look like. 
I'd like to use Gemini for this and then send the results to our internal accounting API.`,
  },
  {
    name: 'Multilingual Archive',
    text: `I'm researching historical archives. 
I'll be uploading a mix of handwritten images and text documents in French and Spanish. 
I need a conversational bot where I can ask questions about the contents in English. 
I don't have a preference for the AI model, just use whatever is free.`,
  },
  {
    name: 'Cross-Media Project',
    text: `We are dealing with a huge volume of different files—videos, audio recordings of meetings, and some PDFs. 
We need to group them by project and get a high-level summary of everything. We're using Azure Blob Storage. After the summary is generated,
I want to be able to run my own custom prompts to refine the legal language in the summaries.`,
  },
  {
    name: 'Contract Entity Mapping',
    text: `I need to go through our project contracts and find all the Subcontractors and Lead Consultants. 
For each one, please pull out their Tax ID number, Contract Expiry Date, and Total Milestone Payment. 
I'm going to upload the files here and I want to use the built-in model. Oh, and some of the older contracts are in German, 
so please handle those too.`,
  },
];
